const ExpandablePanelBody = (props) => {
  return (
    <div
      className={`transition-all ${
        props.expanded ? "" : "hidden"
      }`}
    >
      <div className="p-4">{props.children}</div>
    </div>
  );
};

export default ExpandablePanelBody;
